import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AppState} from "../../../states/app.state";
import {UserInterface} from "../../../models/user.interface";
import {Store} from "@ngxs/store";
import {UserAction} from "../../../actions/user-action";
import Authenticate = UserAction.Authenticate;
import {StorageService} from "../../../services/storage.service";
import FetchProfile = UserAction.FetchProfile;
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  // LOGIN
  loginForm: FormGroup;

  loginSubmitted = false;

  authenticationError = null;

  @Input()
  formType: string;

  @Output()
  onLoginSuccess = new EventEmitter<{ status: boolean, user: UserInterface}>();

  @Output()
  onGoToRegister = new EventEmitter();

  constructor(private store: Store, private storageService: StorageService, private formBuilder: FormBuilder) {

    store.select(AppState.profile).subscribe((u: UserInterface) => {

      if (u.token && u.refreshToken) {

        this.onLoginSuccess.emit({ status: true, user: u });
      } else {

        this.onLoginSuccess.emit({ status: false, user: u });
        this.authenticationError = this.loginSubmitted ? ( u?.authError || 'Error desconocido. Comuníquese con soporte técnico.' ) : null;
      }
    });
  }

  ngOnInit(): void {

    this.loginSubmitted = false;
    this.initLoginForm(this.loginForm?.value?.email);
  }


  initLoginForm(email?: string) {

    let pwd = '';
    if (!environment.production) {

      pwd = '123456';
      email = email || 'admin@cf.com';
    }

    this.loginForm = this.formBuilder.group({
      email: [email, [ Validators.required, Validators.email] ],
      password: [ pwd, [ Validators.required, Validators.minLength(3)]]
    });
  }

  async login() {

    this.loginSubmitted = true;
    this.authenticationError = false;

    if (!this.loginForm.valid) {

      return;
    }

    this.store.dispatch(new Authenticate(this.loginForm.value.email, this.loginForm.value.password, false))
      .subscribe((data) => {

        const profile = data?.appData?.profile;
        this.storageService.profile = profile;

        if (profile?.token && !profile?.authError) {

          this.store.dispatch(new FetchProfile(profile.id, false));

        } else {

          this.authenticationError = profile?.authError || 'Error desconocido. Comuníquese con soporte técnico.';
        }
      });
  }

  loginHasError(field, fieldError) {

    const control = this.loginForm.get(field);
    return this.loginSubmitted && control.errors && control.errors[fieldError];
  }

}
